import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import classNames from 'classnames';

interface Props extends React.PropsWithChildren {
  auto?: boolean;
  open?: boolean;
  onClose?: () => void;
  overlayClose?: boolean;
}

export default function ModalWrapper({
  auto = true,
  children,
  open = false,
  onClose = () => null,
  overlayClose = true,
}: Props) {
  return (
    <Transition appear show={open} as={React.Fragment}>
      <Dialog as='div' className='relative z-10' onClose={overlayClose ? onClose : () => null}>
        <Transition.Child
          as={React.Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center sm:p-4 text-center'>
            <Transition.Child
              as={React.Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel
                className={classNames(
                  auto ? 'w-auto' : 'w-full',
                  'max-w-2xl transform overflow-hidden rounded-2xl bg-white dark:bg-[#242424] dark:text-white p-6 text-left align-middle shadow-xl transition-all',
                )}
              >
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
